import React from "react";
import { useI18n } from "@/i18n";
import { Plane, Map, Clock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

function ServiceCard({ s, lang, t, onSelectService }) {
  const name = lang === "it" ? s.name_it : s.name_en;
  const desc = lang === "it" ? s.description_it : s.description_en;
  return (
    <div
      data-testid={`service-card-${s.id}`}
      className="group bg-white rounded-2xl p-7 border border-slate-200/70 shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(10,36,99,0.1)] transition-all duration-300 flex flex-col"
    >
        <div className="flex items-start justify-between">
          <div className="w-12 h-12 rounded-xl brand-bg text-white grid place-items-center">
            {s.category === "transfer" ? <Plane className="w-5 h-5" /> : <Map className="w-5 h-5" />}
          </div>
          <div className="text-right">
            <div className="text-xs uppercase tracking-widest text-slate-400">{t.services.from}</div>
            <div className="font-display text-2xl brand-text">€{s.price_eur.toFixed(0)}</div>
          </div>
        </div>
        <h3 className="font-display text-xl md:text-2xl mt-6 brand-text leading-snug">{name}</h3>
        <p className="text-sm text-slate-600 mt-3 flex-1">{desc}</p>
        <div className="flex items-center justify-between mt-6 pt-6 border-t border-slate-100">
          <div className="flex items-center gap-2 text-xs text-slate-500">
            <Clock className="w-4 h-4" />
            <span>
              {t.services.duration}: {s.duration_min} {t.services.min}
            </span>
          </div>
          <Button
            data-testid={`service-book-btn-${s.id}`}
            onClick={() => onSelectService(s.id)}
            variant="ghost"
            className="text-[#0A2463] hover:bg-[#0A2463]/5 rounded-full"
          >
            {t.services.book} <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </div>
    );
}

export default function ServicesSection({ services, onSelectService }) {
  const { lang, t } = useI18n();

  if (!services || services.length === 0) return null;

  const transfers = services.filter((s) => s.category === "transfer");
  const tours = services.filter((s) => s.category === "tour");

  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.3em] accent-text">{t.services.eyebrow}</p>
          <h2 className="font-display text-4xl md:text-5xl brand-text mt-4 leading-tight">
            {t.services.title}
          </h2>
          <p className="text-base md:text-lg text-slate-600 mt-5">{t.services.lead}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {transfers.map((s) => (
            <ServiceCard key={s.id} s={s} lang={lang} t={t} onSelectService={onSelectService} />
          ))}
        </div>
        <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tours.map((s) => (
            <ServiceCard key={s.id} s={s} lang={lang} t={t} onSelectService={onSelectService} />
          ))}
        </div>
      </div>
    </section>
  );
}
